// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"5f2c18d4","186":"22e05f47","225":"c2026b95","272":"70f5df5d","372":"b6e41f69","377":"fbfcd397","738":"719e399b","841":"b555e077","856":"401ece10"}[chunkId] + ".chunk.js";
};